import {generateClient} from 'aws-amplify/api';
import {testingApiConfig} from './config/index.ts';

// The testing-api is not deployed to every stage the console runs in (see
// ./config — there is no prod endpoint by decision), so unlike the workflows /
// screenshots integrations this client cannot be created at module load. Callers
// go through `getTestingApiClient()`, which throws a readable error rather than
// letting Amplify issue a request against `undefined`.
const client = testingApiConfig
    ? generateClient({
                         endpoint: testingApiConfig.endpoint,
                         region: testingApiConfig.region,
                         authMode: 'userPool',
                     })
    : undefined;

export const getTestingApiClient = () => {
    if (typeof client === 'undefined') {
        throw new Error('The Testing API is not available in this environment');
    }
    return client;
};
